import { FiSettings } from 'react-icons/fi';
import Button from './atoms/Button';
import { IconPlay1 } from './icons';
import MenuDropdown from './atoms/MenuDropdown';

interface DropdownItem {
  label: string;
  onClick: (data?: unknown) => void;
  hidden?: boolean;
}

interface SideButtonConfig {
  label?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'tertiary';
  icon?: React.ReactNode;
  disabled?: boolean;
  hidden?: boolean;
  loading?: boolean;
}

interface MainButtonConfig extends SideButtonConfig {
  image?: string;
  imageInverted?: boolean;
  mobileLabel?: string;
}

interface AdminSectionTitleProps {
  title: string;
  subtitle?: string;
  dropdownItems?: DropdownItem[];
  mainButtons?: MainButtonConfig[];
  sideButtons?: SideButtonConfig[];
  className?: string;
  icon?: React.ReactNode;
}

const AdminSectionTitle = ({
  title, subtitle, sideButtons, mainButtons, className, icon, dropdownItems,
}: AdminSectionTitleProps) => (
  <div className={`flex flex-col gap-8 self-stretch ${className}`}>
    <div className={`${subtitle ? 'flex flex-row items-center gap-4' : 'flex flex-col md:flex-row gap-4'}`}>
      <div className="flex flex-row items-center gap-4">
        <h1 className="text-3xl text-text-primary font-medium">{title}</h1>
        {icon && <div className="flex-shrink-0">{icon}</div>}
        {!icon && <div className="flex-shrink-0"><IconPlay1 className='w-12 h-12' /></div>}
      </div>
      {mainButtons && mainButtons.length > 0 && !subtitle && (
        <div className={`flex flex-row gap-2 items-center justify-center pr-1 ${mainButtons && mainButtons.length === 1 ? 'md:ml-auto' : 'md:mx-auto'}`}>
          {mainButtons.map((button, index) => (
            !button.hidden && (
              <Button key={index} onClick={button.onClick} variant={button.variant} disabled={button.disabled} loading={button.loading}>
                <div className="flex items-center justify-center gap-2 p-2">
                  {button?.icon && button.icon}
                  {button?.image && <img src={button.image} alt={button.label} className={`${button.disabled ? 'brightness-50' : 'brightness-0'} min-w-[20px] min-h-[20px] w-5 h-5 ${button.imageInverted ? 'invert' : ''}`} />}
                  {button.label && <p className="hidden min-[1150px]:block whitespace-nowrap">{button.label}</p>}
                  {button.mobileLabel && <p className="block min-[1150px]:hidden whitespace-nowrap">{button.mobileLabel}</p>}
                </div>
              </Button>
            )
          ))}
          <div className='flex gap-2 items-center ml-2'>
            {dropdownItems && dropdownItems.length > 0 && (
              <MenuDropdown
                options={dropdownItems}
                data={dropdownItems}
                icon={<FiSettings className="text-2xl text-primary-500" />}
              />
            )}
          </div>
        </div>
      )}
    </div>
    {subtitle && (
      <div>
        <h1 className={`flex ${mainButtons && mainButtons.length === 1 ? 'flex-row' : 'flex-col md:flex-row'} gap-2 text-2xl`}>
          <div className="flex flex-row gap-2 items-center">
            {subtitle}
            {sideButtons && (
              <div className="flex gap-2">
                {sideButtons.map((button) => (
                  !button.hidden && (
                    <div key={button.label} className="flex items-center justify-center w-10 whitespace-nowrap bg-blur-sm bg-opacity-light rounded-3xl">
                      <Button
                        onClick={button.onClick}
                        variant={button.variant}
                        disabled={button.disabled}
                      >
                        {button.icon}
                        {button.label}
                      </Button>
                    </div>
                  )))}
              </div>
            )}
          </div>
          {mainButtons && mainButtons.length > 0 && subtitle && (
            <div className={`flex flex-row gap-2 items-center pr-1 ${mainButtons && mainButtons.length === 1 ? 'ml-auto' : 'md:ml-auto'}`}>
              {mainButtons.map((button, index) => (
                !button.hidden && (
                  <Button key={index} onClick={button.onClick} variant={button.variant} disabled={button.disabled} loading={button.loading}>
                    <div className="flex items-center justify-center gap-2 p-2">
                      {button?.icon && button.icon}
                      {button?.image && <img src={button.image} alt={button.label} className={`${button.disabled ? 'brightness-50' : 'brightness-0'} min-w-[20px] min-h-[20px] w-5 h-5 ${button.imageInverted ? 'invert' : ''}`} />}
                      {button.label && <p className="hidden min-[1150px]:block whitespace-nowrap">{button.label}</p>}
                      {button.mobileLabel && <p className="block min-[1150px]:hidden whitespace-nowrap">{button.mobileLabel}</p>}
                    </div>
                  </Button>
                )
              ))}
              <div className='flex gap-2 items-center ml-2'>
                {dropdownItems && dropdownItems.length > 0 && (
                  <MenuDropdown
                    options={dropdownItems}
                    data={dropdownItems}
                    icon={<FiSettings className="text-2xl text-primary-500" />}
                  />
                )}
              </div>
            </div>
          )}
        </h1>
      </div>
    )}
  </div>
);

export default AdminSectionTitle;
